import { useCallback } from 'react';
import { canUseEOLVoiceV1, canUseEOLVoiceV2 } from '@src/services/voice';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useFeatureFlags from './useFeatureFlags';

export const useCanUseEOLVoice = () => {
  const { getFeatureValue } = useFeatureFlags();
  const canUseEOLVoice = useCallback(({ voice, user }) => {
    const userVoiceEolEnabled = getFeatureValue(FEATURE_KEYS.USER_VOICE_EOL, {
      userId: user.id,
    });

    return userVoiceEolEnabled
      ? canUseEOLVoiceV2({ voice, user })
      : canUseEOLVoiceV1({ voice, user });
  }, []);

  return { canUseEOLVoice };
};
